import React from 'react';
import { AdvanceBookingDaysFields } from '../building-utilities/AdvanceBookingDaysFields';

export type ServiceAdvanceBookingSettingsValue = {
  advanceBookingDays: { min: number; max: number };
  staffAdvanceBookingDays: { min: number; max: number };
};

interface ServiceAdvanceBookingSettingsProps {
  value: ServiceAdvanceBookingSettingsValue;
  onChange: (next: ServiceAdvanceBookingSettingsValue) => void;
}

export const ServiceAdvanceBookingSettings: React.FC<ServiceAdvanceBookingSettingsProps> = ({
  value,
  onChange,
}) => (
  <div className="space-y-4 border-t pt-4 mt-4">
    <h4 className="text-sm font-semibold text-gray-800">Cài đặt đặt trước</h4>
    <p className="text-xs text-gray-500">Áp dụng cho ngày bắt đầu đăng ký (thi công / ra vào / chuyển đồ).</p>
    <AdvanceBookingDaysFields
      value={value.advanceBookingDays}
      onChange={(advanceBookingDays) => onChange({ ...value, advanceBookingDays })}
      minLabel="Đặt trước tối thiểu (ngày) — cư dân"
      maxLabel="Đặt trước tối đa (ngày) — cư dân"
    />
    <AdvanceBookingDaysFields
      value={value.staffAdvanceBookingDays}
      onChange={(staffAdvanceBookingDays) => onChange({ ...value, staffAdvanceBookingDays })}
      allowNegativeMin
      minLabel="Đặt trước tối thiểu (ngày) — nhân viên"
      maxLabel="Đặt trước tối đa (ngày) — nhân viên"
    />
  </div>
);

export default ServiceAdvanceBookingSettings;
